import styled from "styled-components";

import { StyledDialogContent } from "@styles/components/Dialog.styled";
import {
  alignItemsCenter,
  alpha,
  circle,
  flexCenter,
  flexSpBetween,
  rem,
  size,
} from "@styles/Utilities.styled";


export const StyledTimelineFilterDialogContent = styled(StyledDialogContent)`
  width: min(90vw, ${rem(675)});
  max-height: unset;
  padding-bottom: 1rem;

  .dialog-header {
    border-bottom: none;
  }

  .filters-wrapper {
    display: flex;
    gap: 2.5rem;
    margin-top: 1.5rem;
  }

  .filter-column {
    & > p {
      font-size: ${rem(14)};
      text-transform: uppercase;
      font-weight: 500;
      padding-bottom: 0.25em;
      border-bottom: 1px solid ${alpha("var(--clr-black)", 0.3)};
    }

    .clear-filter-btn {
      font-size: ${rem(14)};
      color: var(--clr-primary-400);
      text-align: left;
    }
  }

  .RadioGroupRoot {
    display: flex;
    flex-direction: column;
    gap: ${rem(10)};
    margin-top: 1rem;

    & > div {
      ${alignItemsCenter}
      gap: 0.5rem;

      button[data-state="checked"] ~ .Label {
        color: var(--clr-primary-700);
        font-weight: 500;
      }

      label {
        color: var(--clr-gray-400);
        font-size: ${rem(14)};
        font-weight: 400;
        line-height: 1;
        margin-bottom: 0;
        text-transform: capitalize;
        cursor: pointer;
        color: var(--clr-gray-400);
      }
    }
  }

  .RadioGroupItem {
    background-color: white;
    ${circle(rem(23))}
    /* box-shadow: 0 2px 10px ${alpha("var(--clr-primary-700)", 0.2)}; */
    border: 1px solid var(--clr-gray-200);
  }
  .RadioGroupItem:hover {
    background-color: var(--clr-primary-100);
  }
  .RadioGroupItem:focus {
    box-shadow: 0 0 0 2px ${alpha("var(--clr-primary-400)", 0.8)};
  }

  .RadioGroupIndicator {
    position: relative;
    ${flexCenter}
    ${size("100%")}
  }
  .RadioGroupIndicator::after {
    content: "";
    display: block;
    ${circle(rem(10))}
    background-color: var(--clr-primary-400);
  }

  .dialog-footer {
    ${flexSpBetween}
    padding-bottom: 0rem;
  }
`;
